import '../../../../node_modules/intersection-observer';
import IntersectionObject from './IntersectionObject';

export default class IntersectionManager {
    constructor(opt = {}){

        this.selector = (typeof(opt.selector) !='undefined') ? opt.selector : '.ef-scroll';
        this.collection = [];
        this.initIntersection();
    }

    initIntersection() {
        const options = {
            "rootMargin": '-10% 0px'
        };
        this.observer = new IntersectionObserver((entries,object)=>{
            //callback
            let _this = this;
            entries.forEach(function (entry, i) {
                //交差していない場合終了
                if (!entry.isIntersecting) return;
                //交差対象オブジェクト
                const tgt = entry.target;
                //コレクション
                //tgt.classList.remove("ef-scroll");
                _this.getIO(tgt);
                //監視対象から除外
                object.unobserve(tgt);

            })
        }, options);
    }
    addObject(intersectionObjct){
        this.collection.push(intersectionObjct);
    }

    startIntersection() {
        //let _this = this;

        for(let i=0;i<this.collection.length;i++){
            this.observer.observe(this.collection[i].$dom[0])
        }
        /*$(this.selector).each(function(){
            let io = new IntersectionObject($(this));
            _this.collection.push(io);
            _this.observer.observe($(this)[0])
        });*/
    }

    getIO(tgt){
        for(let item of this.collection){
            if(item.$dom[0] === tgt){
                item.observe();
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/scripts/effects/intersection/IntersectionManager.js